import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import { Box, CssBaseline } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Sidebar from './components/sidebar/Sidebar';
import DisparadorWrapper from './components/home/Disparador';
import BrokerModalWrapper from './components/modal_broker/BrokerModal';
import WabaModalWrapper from './components/modal_waba/WabaModal';
import Header from './components/header/Header';
import InstaModal from './components/instagram/instaModal';

// Função para decodificar o token e extrair a linguagem
const extractLanguageFromToken = (token) => {
  try {
    // Decodificar base64
    const decodedToken = atob(token);
    // Separar por | (pipe)
    const parts = decodedToken.split('|');
    
    if (parts.length >= 2) {
      const language = parts[1].toLowerCase();
      // Validar se é uma linguagem suportada
      if (['pt', 'en', 'es'].includes(language)) {
        return language === 'pt' ? 'pt-BR' : language === 'en' ? 'en' : 'es';
      }
    }
  } catch (error) {
    console.error('Erro ao decodificar token:', error);
  }
  
  // Padrão: português
  return 'pt-BR';
};

function App() {
  return (
    <Router>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <Sidebar />
        <Box component="main" sx={{ flexGrow: 1, bgcolor: '#f9f9f9', height: '100vh' }}>
          <Routes>
            <Route path=":acontID/:token" element={<DisparadorWithModals />} />
            <Route path=":acontID/:token/disparador" element={<DisparadorWithModals />} />
            <Route path=":acontID/:token/instagram" element={<InstaModalWithHeader />} />
          </Routes>
        </Box>
      </Box>
    </Router>
  );
}

const DisparadorWithModals = () => {
  const { acontID, token } = useParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    const language = extractLanguageFromToken(token);
    if (i18n.language !== language) {
      i18n.changeLanguage(language);
    }
  }, [token, i18n]);

  return (
    <>
      <Header acontID={acontID} token={token} />
      <DisparadorWrapper acontID={acontID} token={token} />
      <BrokerModalWrapper acontID={acontID} token={token} />
      <WabaModalWrapper acontID={acontID} token={token} />
    </>
  );
};

// Adding InstaModal with Header
const InstaModalWithHeader = () => {
  const { acontID, token } = useParams();
  const { i18n } = useTranslation();

  // Configurar linguagem baseada no token quando o componente montar
  useEffect(() => {
    const language = extractLanguageFromToken(token);
    if (i18n.language !== language) {
      i18n.changeLanguage(language);
    }
  }, [token, i18n]);

  return (
    <>
      <Header acontID={acontID} token={token} />
      <InstaModal acontID={acontID} token={token} />
    </>
  );
};

export default App;